import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M16.7696 19.6357H18.1446C20.4228 19.6357 22.2696 17.7889 22.2696 15.5107C22.2696 13.2325 20.4228 11.3857 18.1446 11.3857C18.101 11.3857 18.0576 11.3864 18.0144 11.3877C18.0179 11.3041 18.0196 11.2201 18.0196 11.1357C18.0196 7.822 15.3333 5.13571 12.0196 5.13571C9.39119 5.13571 7.15752 6.8258 6.34606 9.17851C3.76466 9.5091 1.76959 11.7144 1.76959 14.3857C1.76959 17.2852 4.1201 19.6357 7.01959 19.6357H7.26959M12.0196 12.1357V19.6357M12.0196 19.6357L14.5196 17.1357M12.0196 19.6357L9.51959 17.1357",
      stroke: "#FF0000",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }